var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex flex-c pagination"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","total":_vm.total,"page-size":_vm.page_size},on:{"current-change":_vm.currentChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }